import { Component, EventEmitter, Output } from '@angular/core'

import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { CustomerPortalSharedModule } from '@inside-hub-app/customer-portal-shared'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'
import { NgxGlideModule } from 'ngx-glide'
import { GoogleMapsModule } from '@angular/google-maps'
import { A11yModule } from '@angular/cdk/a11y'
import { TextFieldModule } from '@angular/cdk/text-field'

interface BeforeInstallPromptEvent extends Event {
  prompt (): Promise<void>
}

declare global {
  interface Window {
    installPrompt?: BeforeInstallPromptEvent
  }
}

@Component({
  selector: 'customer-portal-pwa-promo-banner',
  standalone: true,
  templateUrl: './pwa-promo-banner.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CustomerPortalSharedModule,
    HubChildTranslateModule,
    NgxSkeletonLoaderModule,
    NgxGlideModule,
    GoogleMapsModule,
    A11yModule,
    TextFieldModule
  ]
})
export class PwaPromoBannerComponent {
  @Output() public bannerDismiss = new EventEmitter<MouseEvent>()
  dismissBanner (event: MouseEvent): void {
    this.bannerDismiss.emit(event)
  }

  promptInstall (): void {
    const installPrompt = globalThis.installPrompt
    if (installPrompt) {
      installPrompt.prompt()
    }
  }
}
